import { render } from "./BlogCardGroup.vue?vue&type=template&id=36668683&scoped=true"
import script from "./BlogCardGroup.vue?vue&type=script&lang=js"
export * from "./BlogCardGroup.vue?vue&type=script&lang=js"

import "./BlogCardGroup.vue?vue&type=style&index=0&id=36668683&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36668683"]])

export default __exports__